
import { User, Session } from '../types';
import { signUpWithEmailPassword } from './authOperations';

export async function performSignup(email: string, password: string, metadata?: Record<string, any>) {
  const { user, session } = await signUpWithEmailPassword(email, password, metadata);
  
  if (user && session) {
    const newUser: User = {
      ...user,
      name: metadata?.name || '',
      subscriptionTier: 'free',
      profileImage: null,
      provider: 'email'
    };
    
    return { user: newUser, session };
  }
  
  throw new Error('Signup failed: No user or session returned');
}
